import tinycolor from "@ctrl/tinycolor";

export const isLight = (color: string) => tinycolor(color).isLight();

export const isDark = (color: string) => tinycolor(color).isDark();